export const TERMS_AND_CONDITIONS = {
  FETCH: {
    REQUEST: Symbol('TERMS_FETCH_REQUEST'),
    SUCCESS: Symbol('TERMS_FETCH_SUCCESS'),
  },
};

/**
 * @param {*} termsAndConditions
 * @return {{type: *, payload: {termsAndConditions: * }}}
 */
export const termsAndConditionsFetchSuccessAction = (termsAndConditions) => ({
  type: TERMS_AND_CONDITIONS.FETCH.SUCCESS,
  payload: {
    termsAndConditions: termsAndConditions,
  },
});
